
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  Users, 
  FileText, 
   
  Settings,
  Home,
  BarChart3
} from 'lucide-react';

const adminRoutes = [
  {
    path: '/admin/tools',
    label: 'Dashboard',
    icon: Home,
    description: 'Admin overview and tools'
  },
  {
    path: '/admin/claims',
    label: 'Claims Management',
    icon: Users,
    description: 'Review nursing home ownership claims'
  },
  {
    path: '/admin/guides',
    label: 'Content Management',
    icon: FileText,
    description: 'Manage guides and content'
  }
];

export default function AdminNavigation() {
  const location = useLocation();

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {adminRoutes.map((route) => {
        const Icon = route.icon;
        const isActive = location.pathname === route.path;
        
        return (
          <Card key={route.path} className={`transition-all hover:shadow-md ${
            isActive ? 'ring-2 ring-grandpal-green' : ''
          }`}>
            <CardContent className="p-6">
              <Link to={route.path}>
                <div className="flex flex-col items-center text-center space-y-3">
                  <div className={`p-3 rounded-full ${
                    isActive ? 'bg-grandpal-green text-white' : 'bg-gray-100'
                  }`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">{route.label}</h3>
                    <p className="text-sm text-muted-foreground mt-1">
                      {route.description}
                    </p>
                  </div>
                </div>
              </Link>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
